// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".newsCard[data-v-1a568a38]{border:1px solid #f2f2f2;padding:20px}.newsCard .h4[data-v-1a568a38]{color:#333}.newsCard p[data-v-1a568a38]{margin-top:10px;font-size:12px}.newsCard .message[data-v-1a568a38]{display:flex}.newsCard .message>div[data-v-1a568a38]{color:#aaa;font-size:12px}.newsCard .about[data-v-1a568a38],.newsCard .message>div>span[data-v-1a568a38]{font-size:12px}.newsCard .about>span[data-v-1a568a38]{font-size:12px;color:#507afb}", ""]);
// Exports
module.exports = exports;
